import './referencesblock.less'

import {m} from '@codeurs/front'
import {ExternalLinkIcon, FileIcon, InternalLinkIcon} from 'assets/inline-icons'
import {FunctionComponent} from 'react'
import {LinkType} from 'types'
import {PageLink as Link} from 'util/pagelink'
import {style} from 'util/style'
import {Block} from 'views/blocks/blocks'

export type ReferencesBlockType = {
	links: Array<LinkType>
	layout: Array<string>
}

const styles = style('referencesblock', [
	'entry',
	'external',
	'file',
	'reference',
	'title'
])

export const ReferencesBlock: FunctionComponent<ReferencesBlockType> = ({
	links,
	layout
}) => (
	<Block class={styles.mod(layout)}>
		{links.map((link: LinkType) => (
			<ReferenceLink {...link} />
		))}
	</Block>
)

const ReferenceLink: FunctionComponent<LinkType> = link => {
	return (
		<div class={styles.reference()}>
			<Link
				to={link.url}
				target={'_blank'}
				class={styles.reference('link').with(link.type)}
			>
				{getIcon(link.type)}
				<span class={styles.reference('link-text')}>
					{link.description || link.title || link.path}
				</span>
			</Link>
		</div>
	)
}

const getIcon = (type: string) => {
	switch (type) {
		case 'external':
			return <ExternalLinkIcon className={styles.reference('link-icon')} />
		case 'entry':
			return <InternalLinkIcon className={styles.reference('link-icon')} />
		case 'file':
			return <FileIcon className={styles.reference('link-icon')} />
	}
}
